import {applyMiddleware, createStore} from "redux";
import rootReducer from "./RootReducer";
import thunk from "redux-thunk";
import {setupInterceptors} from "./Api";

const store = createStore(
    rootReducer,
    applyMiddleware(thunk)
);
setupInterceptors(store);
export default store;
